export default [
  {
    path: '/push',
    component: () => import('@/views/push/pushList.vue')
  },
  {
    path: '/push/:pushNo',
    component: () => import('@/views/push/pushDetail.vue')
  }
];
